import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { useFormContext } from "react-hook-form";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupInput } from "src/components/Shared/NewForms/NFLookupInput";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFLookupPriceType } from "src/components/Shared/NewForms/NFLookupPriceType";
import { EnumHelper } from "src/components/../helpers/EnumHelper";
import { AmountHelper } from "src/helpers/AmountHelper";
import { useTranslation } from "react-i18next";
import { NFLookupVariant } from "src/components/Shared/NewForms/NFLookupVariant";
import { NFLookupVendor } from "src/components/Shared/NewForms/NFLookupVendor";

export const SalesOrdersDetailProducts = () => {
  const tableName = "products";
  const { setValue, getValues } = useFormContext();
  const { t } = useTranslation();
  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      newQuantity,
      getValues(`${tableName}.${index}.price`),
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );
    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      getValues(`${tableName}.${index}.quantity`),
      newPrice,
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );
    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };
  return (
    <>
      <NFormTable fieldArray={tableName}>
        <NFLookupProduct fieldName={"productId"} title={t("Product")} width={200} />
        <NFLookupUnit title={t("unit")} fieldName="unitId" width={200} />
        <NFLookupVendor title={t("vendorCode")} fieldName="vendorCode" width={200} />
        <NFLookupVariant title={t("variant")} fieldName="variant" width={200} />
        <NFLookupProduct title={t("productCode")} fieldName="productCode" width={200} />
        <NFIntInput fieldName={"quantity"} title={t("Quantity")} onValueChanged={handleQuantityChanged} width={100} />
        <NFIntInput fieldName={"amount"} title={t("Amount")} width={100} />
        <NFIntInput fieldName={"vatAmount"} title={t("vatAmount")} width={150} />
        <NFLookupInput title={t("vatType")} fieldName={"vatType"} items={EnumHelper.GetVatTypeArrayForLookup()} width={150} />
        <NFIntInput fieldName={"amountWithVat"} title={t("amountWithVat")} width={100} />
        <NFIntInput fieldName={"price"} title={t("Price")} onValueChanged={handlePriceChanged} width={100} />
        <NFLookupPriceType fieldName={"priceTypeId"} title={t("PriceType")} width={250} />
        <NFIntInput
          fieldName={"vatRate"}
          title={t("vatRate")}
          width={100}
          // onValueChanged={handleVatRateChange}
        />
      </NFormTable>
    </>
  );
};
